const tryRequire = require('try-require')
const fs = require('fs-extra')
import _MOVE_MAIN from './move-main'

module.exports = function (state, opts, config) {
    const critical = tryRequire('critical')
    const WebpackOnBuildPlugin = tryRequire('on-build-webpack')

    if (!WebpackOnBuildPlugin || !critical) {
        return {} // waiting for an installation
    }
    
    return new WebpackOnBuildPlugin(_ => {
        return new Promise((resolve, reject) => {
            const res = _ => {
                _MOVE_MAIN(state, opts, config)
                    .then(resolve)
                    .catch(reject)
            }
            if (fs.existsSync(state.PROJECT_PATH + '/dist/client/main/index.html')) {
                critical.generate({
                    inline: true,
                    minify: true,
                    extract: true,
                    timeout: 30000,
                    base: state.PROJECT_PATH + '/dist/client/',
                    src: 'main/index.html',
                    dest: 'main/index-critical.html',
                    width: 1300,
                    height: 900
                }).then(res)
                .catch(reject)
            } else {
                res()
            }
        })
    })
}



// WEBPACK FOOTER //
// ./src/technologies/critical.js